module.exports = __webpack_public_path__ + "static/img/3.f5d1f024.jpg";